import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'parcel-invoices-xml' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
